import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-errorv4',
  templateUrl: './errorv4.component.html',
  styleUrls: ['./errorv4.component.scss']
})
export class Errorv4Component implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
